import React from 'react';
import { AppBar, Toolbar, Typography, InputBase, Box } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import FavoriteIcon from '@material-ui/icons/Favorite';

import useStyles from './styles';

const Header = () => {
    const classes = useStyles();
    return(
        <AppBar position="static">
            <Toolbar className={classes.toolbar}>
                <Typography variant='h5' className = {classes.title}>
                    Travel Advisor
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant='h5'>
                    Made with 
                </Typography>
                <FavoriteIcon spacing={3}/>
                <Typography variant='h5' >
                    by Satyam Soni 
                </Typography>
                </div>
                <Box display="flex">
                    <Typography variant='h6' className = {classes.title}>
                        Explore new places
                    </Typography>
                    {/* <Autocomplete> */}
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <InputBase placeholder='Search... ' classes={{root: classes.inputRoot, input: classes.inputInput}} />
                        </div>
                    {/* </Autocomplete> */}
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default Header;